import React, { useRef } from "react";
import { useWatch } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";
import { useNotification } from "@refinedev/core";

import { Textarea } from "@/components/ui/textarea";

export function TextOverridesField({ id, inputProps }: AutoFormFieldProps) {
  const ref = useRef<HTMLTextAreaElement>(null);
  const value = useWatch({ name: id });
  const { open } = useNotification();

  const parentPath = id.split(".").slice(0, -1).join(".");
  const offerType = useWatch({ name: `${parentPath}.type` });

  if (offerType !== "giveaway") return null;

  return (
    <div className="flex flex-col space-y-2 text-foreground w-full">
      <div className="text-sm">Text Overrides</div>
      <Textarea
        ref={ref}
        placeholder="Enter JSON value"
        className="font-mono"
        defaultValue={value ? JSON.stringify(value, null, 2) : ""}
        onBlur={(e) => {
          try {
            const parsed = JSON.parse(e.target.value);
            inputProps.onChange({
              target: { name: id, value: parsed },
            } as unknown as React.ChangeEvent<HTMLInputElement>);
            if (ref.current) {
              ref.current.value = JSON.stringify(parsed, null, 2);
            }
          } catch {
            open?.({
              message: "Invalid JSON",
              description: "Please enter valid JSON for text overrides",
              type: "error",
            });
          }
        }}
      />
    </div>
  );
}
